import { RxDocument } from 'rxdb'
import { Attr, BaseSchema, ModelSchema } from './helpers'
import { PageSchema } from './PageSchema'
import { UserSchema } from './UserSchema'
import { AttributeSchema } from './AttributeSchema'

@ModelSchema({
  name: 'page_event',
  description: 'Any event relating to a page, either a custom one, or a change like updating an attribute',
  version: 0,
  required: ['type', 'page_id'],
  associations: () => [
    { type: 'belongsTo', model: PageSchema, key: 'page', foreignKey: 'page_id' },
    { type: 'belongsTo', model: UserSchema, key: 'user', foreignKey: 'user_id' },
    { type: 'belongsTo', model: AttributeSchema, key: 'user', foreignKey: 'user_id' },
  ],
})
export class PageEventSchema extends BaseSchema {
  @Attr({ type: 'number' }) type: PageEventType
  @Attr({ type: ['object','null'] }) payload?: any

  user_id?: string
  page_id: string
  attribute_id?: string
}

export type PageEventDoc = RxDocument<PageEventSchema>
export enum PageEventType {
  'custom' = 0,
  'page_create' = 1,
  'page_change' = 2,
  'attribute_value_change' = 3,
}
